import React, { forwardRef, useRef, useState } from "react";
import "../Assets/Styles/SliderSection.css";
import UniversalLife from "./UniversalLife/UniversalLife";
import CriticalIllness from "./CriticalIllness/CriticalIllness";
import TermLife from "./TermLife/TermLife";
import Slider from "react-slick";
import { Container } from "reactstrap";
import { useTranslation } from "../Hooks/useTranslation";
import { useAnimateOnScroll } from "../Hooks/useAnimationScroll";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const OurProducts = forwardRef(({ sectionRef }, ref) => {
  const translations = useTranslation();
  useAnimateOnScroll();

  const [change, setChange] = useState("AM");
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    pauseOnHover: true,
    adaptiveHeight: true,
    beforeChange: (_, next) => {
      if (next === 0) setChange("AM");
      if (next === 1) setChange("Ward");
      if (next === 2) setChange("Great");
    },
  };

  return (
    <div
      id="our-products"
      ref={ref}
      className="supeior-rating py-16 lg:pt-16 lg:pb-36 md:py-[8rem]"
    >
      <Container className="relative ">
        <div className="our-products-header animate__animated xl:absolute  mt-0 mb-4 md:mb-10 animate__fadeInLeft max-w-[420px] w-[100%] z-[9] top-0 lg:pl-0 pl-4 pr-4">
          <h3 className="text-[28px] md:text-[40px] leading-[2.8rem] font-semibold mb-5 md:mb-8 lg:mb-4 tracking-[-0.02em] extra-title-heading">
            {translations.ourProductHeading}
          </h3>

          {/* Tabs */}
          <div className="active-section flex gap-2 bg-white rounded-full mb-4">
            <button
              onClick={() => {
                setChange("AM");
                sliderRef.current?.slickGoTo(0);
              }}
              className={`flex-1 leading-[16px] text-[14px] py-[10px] rounded-full extra-btn-font
                ${change === "AM" ? "bg-[#103F4B] text-white" : "text-black"}`}
            >
              {translations.universalLifeTab}
            </button>

            <button
              onClick={() => {
                setChange("Ward");
                sliderRef.current?.slickGoTo(1);
              }}
              className={`flex-1 leading-[16px] text-[14px] py-[10px] rounded-full extra-btn-font
                ${change === "Ward" ? "bg-[#103F4B] text-white" : "text-black"}`}
            >
              {translations.termLifeTab}
            </button>

            <button
              onClick={() => {
                setChange("Great");
                sliderRef.current?.slickGoTo(2);
              }}
              className={`flex-1 leading-[16px] text-[14px] py-[10px] rounded-full extra-btn-font
                ${change === "Great" ? "bg-[#103F4B] text-white" : "text-black"}`}
            >
              {translations.criticalIllnessTab}
            </button>
          </div>
        </div>

        {/* Slider */}
        <Slider ref={sliderRef} {...settings}>
          <div>
            <UniversalLife isScrollable />
          </div>
          <div>
            <TermLife isScrollable />
          </div>
          <div>
            <CriticalIllness isScrollable />
          </div>
        </Slider>
      </Container>
    </div>
  );
});

OurProducts.displayName = "OurProducts";
export default OurProducts;
